var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "realCom",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.realCom, rules: _vm.roles }
        },
        [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("名称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "name",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.name,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "name", $$v)
                        },
                        expression: "realCom.name"
                      }
                    }),
                    _vm._v(" "),
                    _vm.isAdd
                      ? _c(
                          "span",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: { click: _vm.setRealCom }
                          },
                          [_vm._v("选择实体公司")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("代码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "code",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: {
                        disabled: _vm.realCom.id != null,
                        type: "text",
                        "auto-complete": "off"
                      },
                      model: {
                        value: _vm.realCom.code,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "code", $$v)
                        },
                        expression: "realCom.code"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("是否三证合一")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "integratedFlag" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.realCom.integratedFlag,
                          callback: function($$v) {
                            _vm.$set(_vm.realCom, "integratedFlag", $$v)
                          },
                          expression: "realCom.integratedFlag"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("是")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("否")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("执照注册号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "registNo" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.registNo,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "registNo", $$v)
                        },
                        expression: "realCom.registNo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("统一社会信用代码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "socialCreditCode" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.socialCreditCode,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "socialCreditCode", $$v)
                        },
                        expression: "realCom.socialCreditCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("企业类型")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "orgForm" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.orgForm,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "orgForm", $$v)
                        },
                        expression: "realCom.orgForm"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("组织机构代码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "orgCode" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.orgCode,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "orgCode", $$v)
                        },
                        expression: "realCom.orgCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("法人代表")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "legalPerson" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.legalPerson,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "legalPerson", $$v)
                        },
                        expression: "realCom.legalPerson"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("注册资金")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "registCapital",
                      rules: { validator: _vm.validCapital, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: {
                        type: "number",
                        min: "0",
                        placeholder: "请输入数字"
                      },
                      model: {
                        value: _vm.realCom.registCapital,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "registCapital", _vm._n($$v))
                        },
                        expression: "realCom.registCapital"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("成立日期")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "foundDate" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "width-2x",
                      attrs: { type: "date", placeholder: "选择日期" },
                      model: {
                        value: _vm.realCom.foundDate,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "foundDate", $$v)
                        },
                        expression: "realCom.foundDate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("营业开始日期")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "bizTermStartDate" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "width-2x",
                      attrs: { type: "date", placeholder: "选择日期" },
                      model: {
                        value: _vm.realCom.bizTermStartDate,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "bizTermStartDate", $$v)
                        },
                        expression: "realCom.bizTermStartDate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("营业截止日期")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "bizTermEndDate" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "width-2x",
                      attrs: { type: "date", placeholder: "选择日期" },
                      model: {
                        value: _vm.realCom.bizTermEndDate,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "bizTermEndDate", $$v)
                        },
                        expression: "realCom.bizTermEndDate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("税务登记号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "taxRegistNo" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.taxRegistNo,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "taxRegistNo", $$v)
                        },
                        expression: "realCom.taxRegistNo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("纳税类型编码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "taxPayTypeCode" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      on: { change: _vm.taxPayTypeCodechange },
                      model: {
                        value: _vm.realCom.taxPayTypeCode,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "taxPayTypeCode", $$v)
                        },
                        expression: "realCom.taxPayTypeCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("纳税类型")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "taxPayType",
                      rules: { validator: _vm.validNull, trigger: "change" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.realCom.taxPayTypeName,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "taxPayTypeName", $$v)
                        },
                        expression: "realCom.taxPayTypeName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.selectCustTaxPayType()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("经营范围")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "bizScope" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.bizScope,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "bizScope", $$v)
                        },
                        expression: "realCom.bizScope"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("员工人数")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "staffCount" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: {
                        type: "number",
                        min: "0",
                        placeholder: "请输入数字"
                      },
                      model: {
                        value: _vm.realCom.staffCount,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "staffCount", _vm._n($$v))
                        },
                        expression: "realCom.staffCount"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("是否抵扣税")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "taxFree" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.realCom.taxFree,
                          callback: function($$v) {
                            _vm.$set(_vm.realCom, "taxFree", $$v)
                          },
                          expression: "realCom.taxFree"
                        }
                      },
                      _vm._l(_vm.taxOsJudgeWayList, function(taxOsJudgeWay) {
                        return _c("el-option", {
                          attrs: {
                            label: taxOsJudgeWay.text,
                            value: taxOsJudgeWay.value
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("联系人姓名")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "contactName",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.contactName,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "contactName", $$v)
                        },
                        expression: "realCom.contactName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("联系电话")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "contactTel",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.contactTel,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "contactTel", $$v)
                        },
                        expression: "realCom.contactTel"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("联系邮箱")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "contactEmail",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.realCom.contactEmail,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "contactEmail", $$v)
                        },
                        expression: "realCom.contactEmail"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("公司介绍")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "briefIntro",
                      rules: { validator: _vm.validNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.realCom.briefIntro,
                        callback: function($$v) {
                          _vm.$set(_vm.realCom, "briefIntro", $$v)
                        },
                        expression: "realCom.briefIntro"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39b0b5e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b0b5e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/realCom/MerchantRealComSave.vue
// module id = 2606
// module chunks = 0